import { render, staticRenderFns } from "./AccountUpdate.vue?vue&type=template&id=28d9de42&"
import script from "./AccountUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports